// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6211":"2a028ab3","9168":"6c2539e4"}[chunkId] + ".chunk.css";
};